import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import CloseIcon from '@swf/core/assets/icons/close.svg';
import { FeatureFlag, ResolverTag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import CookieNames from '@swf/core/types/Cookies';
import { canUseDOM } from '@swf/core/utils';

import BannerNotification from '../BannerNotification/BannerNotification';

import {
  TXTWCL_OtherwiseX_weXll_assume_youXre_ELL,
  TXTWCL_We_have_placed_cookies_on_your_ELL,
  TXTWCL_You_can_change_your_Xa_hrefXXf_ELL
} from './CookieNotification.messages.json';
import styles from './CookieNotification.scss';

const CookieNotification: React.FC = () => {
  const cookies = useSelector(select.notification.getCookies);
  const oneTrustEnabled = useFeature(FeatureFlag.EnableOneTrust);
  const visibilityCookieBanner = useFeature(FeatureFlag.VisibilityCookieBanner);
  const {
    notification: { set }
  } = useDispatch<Dispatch>();

  if (
    oneTrustEnabled ||
    !cookies[CookieNames.COOKIE_NOTIFICATION] ||
    !canUseDOM ||
    !visibilityCookieBanner
  ) {
    return null;
  }

  return (
    <BannerNotification position="bottom">
      <p>
        <Translation {...TXTWCL_We_have_placed_cookies_on_your_ELL} />{' '}
        <Translation
          {...TXTWCL_You_can_change_your_Xa_hrefXXf_ELL}
          values={{
            a: (msg: string) => <ResolverLink resolverTag={ResolverTag.Cookies}>{msg}</ResolverLink>
          }}
        />{' '}
        <Translation {...TXTWCL_OtherwiseX_weXll_assume_youXre_ELL} />
      </p>
      <StarsButton
        data-testid="cookie-notification-x-button"
        className={styles.close}
        icon={<CloseIcon />}
        onClick={() => set({ name: CookieNames.COOKIE_NOTIFICATION, value: false })}
        size="small"
        variant="text"
      />
    </BannerNotification>
  );
};

export default CookieNotification;
